import { default as axios } from '../AxiosHelper';
import { getAuthHeader } from '../helpers';

const HintsConnection = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getHints: (data: any) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/translates/hints/list`, data, {
      headers: getAuthHeader(),
    });
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createHint: (data: any) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/translates/hints`, data, {
      headers: getAuthHeader(),
    });
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  updateHint: (id: string, data: any) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/translates/hints/${id}`, data, {
      headers: getAuthHeader(),
    });
  },
  getFiltersHintsList: () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/translates/hints/filter/form`, {
      headers: getAuthHeader(),
    });
  },
  getFormAddHint: () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/translates/hints/form`, {
      headers: getAuthHeader(),
    });
  },
  getFormEditHint: (id: string) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/translates/hints/${id}/form`, {
      headers: getAuthHeader(),
    });
  },
};

export default HintsConnection;
